import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import {useNiftyFiftyTemplate} from 'Event/template/NiftyFifty'
import Title from 'lib/ui/ConfigPanel/Title'
import Slider from 'lib/ui/Slider'
import SelectorButtons from 'lib/ui/SelectorButtons'
import {ControlLabel} from 'lib/ui/typography'

const MAX_FONT_WIDTH = 100
const MIN_FONT_WIDTH = 50

const TEXT_JUSTIFICATION = [
  {label: 'Left', value: 'left'},
  {label: 'Center', value: 'center'},
  {label: 'Right', value: 'right'},
]

export default function Styling(props: {control: UseFormMethods['control']}) {
  const {control} = props
  const template = useNiftyFiftyTemplate()

  return (
    <>
      <Title>Layout</Title>
      <Controller
        name="welcomeTextWidth"
        defaultValue={template.welcomeTextWidth || MAX_FONT_WIDTH}
        control={control}
        render={({value, onChange}) => (
          <Slider
            aria-label="welcome text width"
            min={MIN_FONT_WIDTH}
            max={MAX_FONT_WIDTH}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            unit="%"
            label="Font Width"
          />
        )}
      />
      <ControlLabel>Text Alignment</ControlLabel>
      <Controller
        name="welcomeTextJustify"
        defaultValue={template.welcomeTextJustify}
        control={control}
        render={({value, onChange}) => (
          <SelectorButtons
            onChange={onChange}
            options={TEXT_JUSTIFICATION}
            value={value}
          />
        )}
      />
    </>
  )
}
